/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const staticSliderSX: SxProps<Theme> = {
	'.MuiCard-root': {
		maxWidth: '245px',
		minWidth: '225px',
		maxHeight: '360px',
	},
};
